import React, { useEffect, useState } from "react";
import DashboardServices from "../../services/externalServices/dashboardServices/DashBoardServices";

const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    getDashBoardServices();
  }, []);

  const getDashBoardServices = async () => {
    try {
      const response = await DashboardServices.findAll();
      console.log("getDashBoardServices", response);

      if (response && response.dashboards) {
        // Map the response data to match the structure used in rendering
        const formattedServices = response.dashboards.map((item) => ({
          id: item.id,
          title: item.title,
          description: item.description,
          img: item.image_url,
          alt: item.name,
          comingSoon: item.tags.includes("Coming Soon"), // Display "Coming Soon" if tagged
        }));

        setServices(formattedServices);
      }
    } catch (error) {
      console.log("Error while getting the dashboard services:", error);
    }
  };

  return (
    <div className="container mx-auto py-20" id="servicesSection">
      <div className="text-center mb-12">
        <h6 className="text-blue-500 uppercase tracking-widest">Services</h6>
        <h1 className="text-4xl font-bold">Tours & Travel Services</h1>
        <p className="text-lg mt-4 text-gray-600">
          Your one-stop destination for local taxi services, tour packages,
          airport transfers, movie ticket bookings, and more in Hospete and
          Hampi. Whether you're planning a short trip, a local tour, or need
          reliable transportation, we've got you covered.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {services.length > 0 ? (
          services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-lg shadow-lg hover:shadow-xl transition duration-300 overflow-hidden relative"
            >
              {service.comingSoon && (
                <div className="absolute top-2 left-2 bg-red-500 text-white text-sm px-3 py-1 rounded-md">
                  Coming Soon
                </div>
              )}
              <img
                src={service.img}
                alt={service.alt}
                className="w-full h-52 object-contain p-6"
              />
              <div className="p-6 text-center">
                <h5 className="text-2xl font-bold">{service.title}</h5>
                <p className="text-gray-600 mt-4">{service.description}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-3 text-center">
            <p className="text-gray-500">Loading services...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
